import produce from 'immer';

import remergeStructuredTableSingleInputs from 'notebook/structured-tables/single-inputs/util/remergeStructuredTableSingleInputs';
import {StructuredTable} from 'notebook/structured-tables/StructuredTableConstants';
import TableUtil from 'notebook/tables/TableUtil';

/** Takes a Structured Table with any incorrect Single Inputs and repairs it.
 *
 * This function helps a Structured Table with any incorrect Single Input columns "self-heal" by remerging all
 * Single Inputs as well as removing the `isSingleInput` flag from any columns that should not be
 * Single Inputs.
 */
export default function autofixStructuredTableSingleInputs<TTableMetadata, TRowMetadata>(
  structuredTable: StructuredTable<TTableMetadata, TRowMetadata>
): StructuredTable<TTableMetadata, TRowMetadata> {
  let repairedTable = remergeStructuredTableSingleInputs(structuredTable);
  repairedTable = removeNonContiguousSingleInputs(repairedTable);
  return repairedTable;
}

/** Remove the `isSingleInput` flag from any columns that are after the leading Single Inputs group.  */
function removeNonContiguousSingleInputs<TTableMetadata, TRowMetadata>(
  structuredTable: StructuredTable<TTableMetadata, TRowMetadata>
): StructuredTable<TTableMetadata, TRowMetadata> {
  const [_, singleInputEndIndex] = TableUtil.getSingleInputIndexRange(structuredTable.columns) ?? [-1, -1];
  return produce(structuredTable, (draft) => {
    for (const column of draft.columns.slice(singleInputEndIndex + 1)) {
      if (column.isSingleInput) {
        column.isSingleInput = false;
      }
    }
  });
}
